import _ from 'lodash'
import React from 'react';
import cookie from 'react-cookies'
import moment from 'moment';
import Foundation, {
  MarketFilter,
  ClassicOddsResp,
  ClassicSportEvents,
  SportEventsUpdate,
  Product,
  ViewPath,
  EventOrder,
  Market,
  VIEW,
  UserStatus,
  SportItemMap,
  ViewKeys,
  LocalePath,
  ALL_SPORTS,
  SPORT,
  PRODUCT_CODE,
  OddsFormatMB,
  PLAYER_TYPE,
  PERIODS_DESC,
  GRADING_UNIT_TYPE,
  EventDetail,
  SHOW_NO_TOPLEAGUE_ICON,
  PAGE_TITLE,
  PERIODS_PRIORITY,
  BetType,
  MESSAGES_TYPE_WS,
  EsportMarket,
  BetTypeGroup,
  PREFIX_SPORT_TRANSLATION,
  GROUP_SPORT_PERIODS,
} from "../common/Foundation"
import {
  Base64
} from 'js-base64';
import SameSite from './SameSite';
import $ from 'jquery';
import Constants from './Constants';
import i18next from "i18next";
import { casinoPage } from '../components/CasinoComponent/constants';
const Fingerprint2 = require('fingerprintjs2');


const dates = [];
export default class CommonUtil {

  static saveCookie = (key, value, options) => {
    options = options || {};
    if (value === null) {
      value = '';
      options.expires = -1;
    }
    let expires = '';
    if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
      let date;
      if (typeof options.expires == 'number') {
        date = new Date();
        date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
      } else {
        date = options.expires;
      }
      expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
    }
    let path = options.path ? '; path=' + (options.path) : '';
    let domain = options.domain ? '; domain=' + (options.domain) : '';
    let sameSite = (window.location.protocol === 'https:' && SameSite.isSameSiteCompatible()) ? "; SameSite=None; Secure" : "";
    document.cookie = [key, '=', encodeURIComponent(value), expires, path, domain, sameSite].join('');
  }

  static saveLocalStorePrefs(prefsData){
    const perfs = localStorage.getItem('perfs') || {};
    if (perfs) {
      const options = _.isEmpty(perfs) ? {} : CommonUtil.convertStringToJSON(atob(perfs));
      _.forEach(prefsData, (value, key) =>{
        options[key] = value;
      })
      localStorage.setItem('perfs', btoa(JSON.stringify(options)));
    }
  }

  static getPrefs (){
    const perfs = localStorage.getItem('perfs') || {};
    if (perfs) {
      return  _.isEmpty(perfs) ? {} : CommonUtil.convertStringToJSON(atob(perfs));
    }
    return {};
  }
  
  static getPeriodName(sportPeriods, sportId, periodNumber, isShortDesc) {
    const periodDecs = sportPeriods && sportPeriods.find(period => period.sportId === parseInt(sportId));
    const description = periodDecs ? periodDecs.periodsDescription.find(periodDec => periodDec[0] === parseInt(periodNumber)) : [];
    return !_.isEmpty(description) ? (isShortDesc ? description[PERIODS_DESC.shortDescription] : description[PERIODS_DESC.description]) : '';
  }

  static getEventSetsId(evParent, evChild) {
    let eventId = evChild ? evChild[EventDetail.id] : 0;
    if(evParent.length > 0 && evChild[EventDetail.gradingUnit] !== GRADING_UNIT_TYPE.SETS && evParent[EventDetail.gradingUnit] !== GRADING_UNIT_TYPE.GAMES) {
      eventId = evParent[EventDetail.id];
    }
    return eventId;
  }

  static getMoreBetTeamTotal(event) {
    let periodsMoreBet = [];
    let firstCountMoreBet = 0;
    const countMoreBet = event[EventDetail.moreBets] + event[EventDetail.totalOutrightOdds];
    const evPeriod = event[EventDetail.periods];
    const periodsEvent = Object.keys(evPeriod);
    periodsEvent.forEach((period, index) => {
      if(evPeriod && evPeriod[period] && index > 0) {
        firstCountMoreBet += evPeriod[period][6];
        periodsMoreBet.push(evPeriod[period][6] - 1);
      }
    });
    periodsMoreBet.unshift(countMoreBet - firstCountMoreBet);
    return periodsMoreBet;
  }

  static getPeriodMoreBet(periods, filterPeriods) {
    const result = periods.reduce((listPeriods, item) => {
      if(item === periods[0] || !filterPeriods.includes(item)) {
        listPeriods.push(item);
      }
      return listPeriods;
    }, []);
    return result;
  }

  static fetchParentId(leagueEvent) {
    let tempEvId = 0;
    const leagueParentId = leagueEvent.reduce((eventsId, event) => {
      if (event[EventDetail.parentId] === 0 && !eventsId.includes(event[EventDetail.id])) {
        eventsId.push(event[EventDetail.id]);
        tempEvId = event[EventDetail.id];
      } else if (event[EventDetail.parentId] !== 0 && tempEvId !== event[EventDetail.parentId] && !eventsId.includes(event[EventDetail.parentId])) {
        eventsId.push(event[EventDetail.parentId]);
        tempEvId = event[EventDetail.parentId];
      }
      return eventsId;
    }, []);
    return leagueParentId;
  }

  static findEventParentMoreBet(events) {
    let parentEvent = events && events.length > 1 ? events.find(ev => ev[EventDetail.parentId] === 0) || [] : events[0] || [];
    if(parentEvent && parentEvent.length === 0) {
      parentEvent = events.find(ev => ev[EventDetail.gradingUnit] === GRADING_UNIT_TYPE.SETS);
    }
    return parentEvent;
  }

  static getTypeEventTennis(event, parentEvent) {
    let result = {
      isRegularEvent: event[EventDetail.gradingUnit] === GRADING_UNIT_TYPE.REGULAR,
      isSetEvent: event[EventDetail.gradingUnit] === GRADING_UNIT_TYPE.SETS,
      isGameEvent: event[EventDetail.gradingUnit] === GRADING_UNIT_TYPE.GAMES,
      isRegularEventParent: parentEvent && parentEvent[EventDetail.gradingUnit] === GRADING_UNIT_TYPE.REGULAR,
      isSetEventParent: parentEvent && parentEvent[EventDetail.gradingUnit] === GRADING_UNIT_TYPE.SETS,
      isGameEventParent: parentEvent && parentEvent[EventDetail.gradingUnit] === GRADING_UNIT_TYPE.GAMES
    };
    if(event[EventDetail.isGameInTeamName]) {
      result.isRegularEvent = false;
      result.isGameEvent = true;
    }
    return result;
  }

  static formatCurrentScoreLive(inplayScore, betType){
    return inplayScore && (betType === BetType.THE_1X2 || betType === BetType.HANDICAP || betType === BetType.OU ) ? `[${inplayScore.replace(":","-")}]` : '';
  }

  static getAccountInfo () {
    const accountInfo = localStorage.getItem('a') || {};
    if (accountInfo) {
      return  _.isEmpty(accountInfo) ? {} : CommonUtil.convertStringToJSON(atob(accountInfo));
    }
    return {};
  }

  static getPrefByKey (key){
    const pref = this.getPrefs();
    return pref[key];
  }

  static isEmpty(text) {
    try {
      if (text === null) {
        return true
      }
      switch (typeof text) {
        case 'string':
          return text.trim() === ''
        case 'number':
        case 'boolean':
        case 'function':
          return true
        case 'object':
          return JSON.stringify(text) === JSON.stringify({})
        case 'undefined':
        default:
          return true
      }
    } catch (e) {
      return true
    }

  }

  static decodeBase64(text) {
    try {
      if (this.isEmpty(text)) {
        return ""
      }
      return atob(text)
    } catch (e) {
      return ""
    }
  }

  static convertStringToJSON(text) {
    try {
      return JSON.parse(text)
    } catch (e) {
      return {}
    }
  }

  static generateUUID() {
    function generate() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return generate() + generate() + '-' + generate() + '-' + generate() + '-' +
      generate() + '-' + generate() + generate() + generate();
  };

  static generateDate(time, tz) {
    const today = new Date();  
    const aDate = moment(time + today.getTimezoneOffset() * 60000 + tz * 60000);
    
    return {
      value: aDate.format("YYYY-MM-DD"), 
      str: aDate.format("MM/DD")
    }
  }

  static generateDates(days, tz) {
    if (dates.length == 0) {
      days = days + 1;
      let today = tz ? moment().utcOffset(tz) : moment();

      for (var day = 1; day < days; day++) {
        dates.push({
          value: today.add(1, 'days').format("YYYY-MM-DD"),
          str: today.format("MM/DD")
        });
      }
      return dates;
    } else {
      return dates;
    }
  }

  static toFirstCharacterUpperCase(text) {
    if (_.isEmpty(text)) return ''
    return text.charAt(0).toUpperCase() + text.slice(1)
  }

  static formatBalance(balance) {
    try {
      switch (typeof balance) {
        case 'number':
          return balance.toDollar(2, true)
        case 'string':
          return Number.parseFloat(balance).toDollar(2, true)
        default:
          return balance
      }
    } catch (e) {
      return balance
    }
  }

  /**
   * Convert Mobx Object to Json Object
   */
  static convertMobxObjToJsonObj(mobxObject) {
    return JSON.parse(JSON.stringify(mobxObject))
  }

  /**
   * Get market filter by market display type
   */
  static castToMarketFilter = (marketDisplayType) => {
    switch (marketDisplayType) {
      case "ALL":
        return MarketFilter.All
      case "_1LINE":
        return MarketFilter._1Line
      case "_3LINES":
        return MarketFilter._3Lines
      case "_5LINES":
        return MarketFilter._5Lines
      default:
        return MarketFilter.Error
    }
  }

  /**
   * Update storage by key and value
   */
  static updateStorage = (key, value) => {
    const item = localStorage.getItem(key);
    const updatedItem = _.isEmpty(item) ? {} : CommonUtil.convertStringToJSON(atob(item));
    Object.assign(updatedItem, value);
    localStorage.setItem(key, btoa(JSON.stringify(updatedItem)));
  }

  /**
   * Simulate Object.values (for IE 11)
   */
  static getObjectValues(obj) {
    return Object.keys(obj).map(function (e) {
      return obj[e]
    })

  }

  static fingerPrint = () => {
    var fpResult = "";
    var option = {
      excludeUserAgent: true,
      excludeLanguage: false,
      excludeColorDepth: false,
      excludeScreenResolution: false,
      detectScreenOrientation: true,
      excludeTimezoneOffset: false,
      excludeSessionStorage: false,
      excludeIndexedDB: true,
      excludeAddBehavior: false,
      excludeOpenDatabase: true,
      excludeCpuClass: true, // ie
      excludePlatform: false,
      excludeDoNotTrack: true, // ff
      excludeCanvas: true,
      excludeWebGL: true,
      excludeAdBlock: true,
      excludeHasLiedLanguages: false,
      excludeHasLiedResolution: false,
      excludeHasLiedOs: false,
      excludeHasLiedBrowser: false,
      excludeJsFonts: true,
      excludeFlashFonts: false,
      excludePlugins: true,
      excludeTouchSupport: true
    };
    var fp = new Fingerprint2(option);
    fp.get(function (result) {
      fpResult = result;
    });
    return fpResult;
  }

  static mapLangCountryCode = {
    "en": "en_US",
    "de": "de_DE",
    "fr": "fr_FR",
    "zh-cn": "zh_CN",
    "zh-tw": "zh_TW",
    "id": "id_ID",
    "vi": "vi_VN",
    "ja": "ja_JP",
    "ko": "ko_KR",
    "th": "th_TH",
    "km": "km_KH",
    "es": "es_ES",
    "he": "he_IL",
    "pt": "pt_BR",
    "ru": "ru_RU",
    'tr': "tr_TR",
    "hi": "hi_IN",
    "hy": "hy_AM",
    "ka": "ka_GE",
    "uk": "uk_UA",
    "sv": "sv_SE",
    "fi": "fi_FI",
    "no": "nb_NO"
    ,"it": "it_IT"
  }

  static helpPageLangCodes = {
    'en': 'en_US',
    'zh-tw': 'zh_TW',
    'zh-CN': 'zh_CN',
    'th': 'th'
  }

  static mapHelpPageLanguages = languagesString => {
    if(!languagesString) return {}
    const languages = languagesString.split(',')
    const helpPageLanguages = {}
    for (const [key, value] of Object.entries(CommonUtil.helpPageLangCodes)) {
      if(languages.includes(key)) {
      helpPageLanguages[key] = value
      }
    }
    return helpPageLanguages
  }
  
  static getHelpPageLocaleURL = (localeCode) => {
    const helpPageLanguages = CommonUtil.helpPageLangCodes;
    return helpPageLanguages.hasOwnProperty(localeCode) ? helpPageLanguages[localeCode] : 'zh_CN';
  }
  
  static toLocaleCode = (lng) => {
    let locale = null;
    if (lng !== 'undefined' && lng != null) {
      locale = CommonUtil.mapLangCountryCode[lng.toLowerCase()];
    }
    return (locale != null) ? locale : 'en_US';
  }

  static getCurrentLocaleCode() {
    return CommonUtil.toLocaleCode(CommonUtil.getCurrentLang())
  }

  static localeCodeToLanguageCode = (localeCode) => {
    let language = null;
    if (localeCode !== 'undefined' && localeCode != null) {
      language = _.invert(CommonUtil.mapLangCountryCode)[localeCode];
    }
    return (language != null) ? language : 'en';
  }

  static getSubDomain = () => {
    let parts = document.domain.split('.');
    let domain = document.domain;
    if (parts.length > 2 && isNaN(parts[0])) {
      parts.splice(0, parts.length - 2);
      domain = "." + parts.join(".");
    }
    return domain
  }

  static getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")
    let regex = new RegExp("[\\?&]" + name + "=([^&#]*)")
    let results = regex.exec(window.location.search)
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  static setCookieDomain() {
    let __udata = this.getUserData()
    if (__udata === null) {
      return;
    }
    if (__udata.auth && __udata.skinIsSupportedLastView) {
      let viewPath = this.getViewPathByURLPath();
      let lastView = VIEW.COMPACT;
      if (viewPath === 'compact') {
        lastView = VIEW.COMPACT;
      } else if (viewPath === 'asian'){
        lastView = VIEW.ASIAN;
      } else if (viewPath === 'classic') {
        lastView = VIEW.CLASSIC;
      }

      let lastViewStr = cookie.load('_lastView');
      let lastViewObj = {};

      if (lastViewStr && lastViewStr.trim() !== '') {
        lastViewObj = JSON.parse(Base64.decode(lastViewStr));
      }

      lastViewObj[__udata.loginId.toLowerCase()] = lastView;

      this.saveCookie("_lastView", Base64.encode(JSON.stringify(lastViewObj)), {
        path: "/"
      });
    }
    let afRefCode = this.getParameterByName("a");
    let afTtId = this.getParameterByName("ttid");
    this.setAfTtIdCookie(afTtId);
    this.setArfcCookie(afRefCode);
    // }
  }
  static setArfcCookie(afRefCode) {
    // if (afRefCode) {
    if (afRefCode !== "" && !cookie.load("afrc")) {
      this.saveCookie("afrc", afRefCode, {
        path: "/",
        domain: CommonUtil.getSubDomain(),
        expires: window.env.afrcExpriseTime
      });
    }
  }

  static setAfTtIdCookie(afTtId) {
    if (afTtId !== "" && !isNaN(afTtId) && afTtId == window.parseInt(afTtId)) {
      this.saveCookie("afTtId", afTtId, {
        path: "/",
        domain: CommonUtil.getSubDomain()
      });
    } else {
      afTtId = 0;
      cookie.load("afTtId", afTtId, {
        path: "/",
        domain: CommonUtil.getSubDomain()
      });
    }
  }


    /**
     * The brand supports only Esports
     */
    static isEsportOnlyByBrand = () => {
      return window.env.isBrandOnlyEsport;
    }

    /** The configuaration was applied for brand with full sports. 
     *  But some brand want it only supports esport. Bellow is the combine condition of this setting:
      1. The configuration 'isBrandOnlyEsport' in BO site is true
      2. Param sport in b2b login request is 'e-sports'      
    **/
    static isSpecifyEsportsOnlyByBrand = () => {
      return window.env.isBrandSpecifyOnlyEsport && cookie.load('specifySport') === 'e-sports';
    }

  static getLangByPath = (path) => {
    let strUrl = path.replace(process.env.REACT_APP_ROUTER_BASE, "");
    let res = strUrl.split("/");
    let lang = res[1];
    return lang;
  }


  static getRealIP(__udata, response) {
    let headers = response.headers
    return headers.hasOwnProperty('x-real-ip') ? headers['x-real-ip'] : __udata.userIp
  }

  /**
   * Based on cache version to determine odds is getting or updating.
   * @param {*} data 
   * @param {*} index 
   */
  static cacheVersionData(data, index) {
    var v = '0';
    for (var i = 0; i < data.length; i++) {
      if (data.length === 1) {
        v = data[i][index];
      } else {
        if (i !== 0 && i === data.length - 1)
          v += data[i][index];
        else
          v += data[i][index] + ',';
      }
    }
    return v;
  }

  /**
   * Get current cache version.
   */
  static getCacheVersion() {
    let cacheVersion;
    if (!localStorage.getItem('_version')) {
      localStorage.setItem('_version', [0, 0]);
    }
    cacheVersion = localStorage.getItem('_version');
    return cacheVersion.split(',');
  }

  /**
   * Set current cache version.
   */
  static setCacheVersion(version) {
    return localStorage.setItem('_version', version);
  }

  /**
   * Reset cache version.
   */
  static resetCacheVersion() {
    localStorage.setItem('_version', [0, 0]);
  }

  /**
   * Get Classic View current cache version.
   */
  static getClassicViewCacheVersion() {
    let cacheVersion;
    if (!localStorage.getItem('classic_version')) {
      this.resetClassicViewCacheVersion()
      cacheVersion = [0, 0];
    } else {
      cacheVersion = localStorage.getItem('classic_version');
    }
    return JSON.parse(cacheVersion);
  }

  static getGameCodeByLeagueName(leagueName) {
    return this.getGameNameByLeagueName(leagueName).replaceAll(':', '').replaceAll(' ', '');
  }

  static getGameNameByLeagueName(leagueName) {
      const nameList = leagueName ? leagueName.split('-') : '';
      return nameList.length > 1 ? _.first(nameList).toLowerCase().trim() : 'Other';
  }

  static extractClassicViewVersions(sportsData, versionIndex) {
    let versions = []

    if (sportsData) {
      sportsData.forEach(sportData => {
        versions.push(sportData[versionIndex])
      })
    }
    return versions.length > 0 ? versions.join(',') : '0'
  }

  /**
   * Set Classic View current  cache version.
   */
  static setClassicViewCacheVersion(data) {
    let _version = this.getClassicViewCacheVersion();
    if (data[ClassicOddsResp.liveEvent] || (data[ClassicOddsResp.liveUpdate] && data[ClassicOddsResp.liveUpdate][1].length > 0)) {
      if (data[ClassicOddsResp.liveEvent]) {
        _version[0] = this.cacheVersionData([data[ClassicOddsResp.liveEvent]], ClassicSportEvents.version);
      } else if (data[ClassicOddsResp.liveUpdate] && data[ClassicOddsResp.liveUpdate][1].length > 0) {
        _version[0] = this.cacheVersionData([data[ClassicOddsResp.liveUpdate]], SportEventsUpdate.version);
      }
    }
    if (data[ClassicOddsResp.normalEvent] || (data[ClassicOddsResp.update] && data[ClassicOddsResp.update][1].length > 0)) {
      if (data[ClassicOddsResp.normalEvent]) {
        _version[1] = this.cacheVersionData([data[ClassicOddsResp.normalEvent]], ClassicSportEvents.version);
      } else if (data[ClassicOddsResp.update] && data[ClassicOddsResp.update][1].length > 0) {
        _version[1] = this.cacheVersionData([data[ClassicOddsResp.update]], SportEventsUpdate.version);
      }
    }
    return localStorage.setItem('classic_version', JSON.stringify(_version));
  }

  /**
   * Reset Classic View cache version.
   */
  static resetClassicViewCacheVersion() {
    localStorage.setItem('classic_version', JSON.stringify([0, 0]));
  }

  static getViewPath(currentView) {
    return ViewPath[currentView] || '';
  }

  /**
   * Detect view asia or euro or classic base on URL
   */
  static getViewByURLPath = () => {
    let viewOnURL = this.getViewPathByURLPath();
    switch (viewOnURL) {
      case ViewPath.classicView:
        return ViewKeys.classic;
      case ViewPath.compactView:
        return ViewKeys.compact;
      default: 
        return window.isEnableOldAsianView ? ViewKeys.asia : ViewKeys.compact
    }
  }

  static getViewPathByURLPath = () => {

    let strUrl = window.location.href.replace(process.env.REACT_APP_ROUTER_BASE, "");
    let pathArray = strUrl.split("/");
    let viewPathOnURL = '';
    if (pathArray.length > 3) {
      viewPathOnURL = pathArray[4];

    }
    return viewPathOnURL;
  }

  static getCurrentSkin() {
    return cookie.load('skin')
  }

  static getCurrentPage() {
    return cookie.load('currentPage') || 'sportPageContainer';
  }

  static getCurrentLang() {
    return sessionStorage.getItem('lng') || 'en'
  }

  static getCountry() {
    return localStorage.getItem('country') || 'CN';
  }

  static getUserData(){
    if(_.isNil(localStorage.getItem("__udata"))) {
      return null;
    }
    
    try {
      return JSON.parse(this.getBase64LocalStorage('__udata')) || null
    } catch (e) {
      console.log(e);
      return null;
  }
  }

  static saveUserData(key, value){
    const __udata = this.getUserData();
    if(!__udata) return 
    
    __udata[key] = value;
    CommonUtil.setBase64LocalStorage('__udata', __udata);
  }

  static getUserLanguage() {
    let __udata = this.getUserData();
    if (__udata === null || !__udata.auth) {
      return this.getCurrentLang();
    }
    return this.getLangByLocale(__udata.locale)
  }

  static getLangByLocale (locale){
    for (var key in this.mapLangCountryCode) {
      if (this.mapLangCountryCode.hasOwnProperty(key) && this.mapLangCountryCode[key] === locale) {
        return key;
      }
    }
    return this.getCurrentLang();
  }

  /**
   * Check suspended
   */
  static isSuspended(status) {
    return _.isEqual(status, 'SUSPENDED');
  }

  /**
   * Check invalid user status
   */
  static isInvalidStatus(status) {
    return _.isEqual(status, UserStatus.INACTIVE) || _.isEqual(status, UserStatus.CLOSED);
  }

  /**
   * Check isMaintenance
   */
  static isMaintenance(status) {
    return _.isEqual(status, Product.MAINTENANCE) || _.isEqual(status, Product.WAGERING_SUSPENDED);
  }

  /**
   * Check is pa skin
   */
  static isPA() {
    return window.env.skinName == 'pa' ? true : false
  };

  /**
   * Check is skin6
   */
  static isSkin6() {
    return window.env.skinName == 'skin6' ? true : false
  };

  static isBrandSupportLiveCenter() {
    return window.env.skinName !== 'b8101';
  }
  
  /**
   * 
    unescape XSSFilter
   */
  static unescapeXSS(value) {
    const txt = document.createElement("textarea");
    txt.innerHTML = value;
    return txt.value;
}

  /**
   * Check is B2B Whitelabel skin
   */
  static isB2BWhitelabel() {
    return window.env.skinName == 'whitelabel';
  };

  /**
   * Check is skin have no space between odds number and at character
   */

  /**
   * Check isAbsoluteURL
   */
  static isAbsoluteURL(url) {
    var r = new RegExp('^(?:[a-z]+:)?//', 'i');
    return r.test(url);
  }

  /**
   * Update last view.
   */
  static saveLastViewByLoginId(lastView) {
    if (lastView) {
      let __udata = this.getUserData();
      if (__udata.auth) {
        let lastViewStr = cookie.load('_lastView');
        let lastViewObj = {};

        if (lastViewStr && lastViewStr.trim() !== '') {
          lastViewObj = JSON.parse(Base64.decode(lastViewStr));
        }
        lastViewObj[__udata.loginId.toLowerCase()] = lastView;
        if (!window.env.isWhiteLabel && !window.env.isB2B) {
          this.saveUserData("view", lastView);
        }
        this.saveCookie("_lastView", Base64.encode(JSON.stringify(lastViewObj)), {
          path: "/"
        });
      }
      localStorage.setItem('lastView', lastView);
    }
  }

  static getObjectKeyByValue = (obj, value) => {
    for (let key of Object.keys(obj)) {
      if (obj[key] === value) {
        return key
      }
    }
  }

  static buildRouter = (props = { history: {}, location: {}, match: {} }) => {
    const { history, location, match } = props;
    return {
      router: { history, location, match }
    };
  }

  static convertEventSorting(order) {
    let eventOrder
    if (isNaN(order)) {
      switch (order.toLowerCase()) {
        case 'time':
          eventOrder = EventOrder.Time
          break
        case 'league':
          eventOrder = EventOrder.League
            break
        default:
          eventOrder = EventOrder.Time
      }
    } else {
        eventOrder = order
    }
    return eventOrder
  }

  /**
   * sort Sport priority for user after login
   * @param {*} sportsSorting 
   * @param {*} data 
   */
  static sortSportsPriority = (sports, sportsSorting) => {
    if (sportsSorting && sports) {
      sportsSorting = !sportsSorting.startsWith(',') ? [',', sportsSorting, ','].join('') : sportsSorting;
      return sports.sort((a, b) => {
        let pa = sportsSorting.indexOf("," + (a[0] || a.sportId) + ",")
        let pb = sportsSorting.indexOf("," + (b[0] || b.sportId)  + ",")
        if (pa < 0){
          pa = 9999
        }
        if (pb < 0){
          pb = 9999
        }
        return pa - pb
      })
    }
    return sports
  }


  static initScrollHeightForLeftSidebar = () => {
    const $footer = $("#footer")
    const $buttons = $(".ButtonSelectionComponent")
    const $sportTab = $(".SportTabComponent")
    const $announcements = $("#announcements")
    const $header = $("#wrapper-header")
    const $betslipTab = $(".BetslipTabsComponent")
    const $body = $("#body")
    const $balance = $(".BalanceComponent")
    const $attention = $(".attention")
    const $specialLeague = $("#ShortcutSpecialLeagueComponent")

    const top_of_screen = $(window).scrollTop();
    const top_of_footer = $footer.length > 0 ? $footer.offset().top : 0

    const bottom_of_footer = $footer.length > 0 ? ($footer.offset().top + $footer.outerHeight()) : 0
    const bottom_of_screen = $(window).scrollTop() + $(window).innerHeight()
    const height_of_button_selection = $buttons.length > 0 ? $buttons.outerHeight() : 0
    const height_of_sport_tab = $sportTab.length > 0 ? $sportTab.outerHeight() : 0
    const height_of_betslip_tab = $betslipTab.length > 0 ? $betslipTab.outerHeight() : 0
    const height_of_special_league = $specialLeague.length > 0 ? $specialLeague.outerHeight() : 0

    const height_of_header = $header.length > 0 ? $header.outerHeight() : 0
    const currentViewport = $(window).innerHeight()
    const totalFixedHeight = //include header's height, buttons's height, sport tab height, betslip tab height, special league height
      height_of_header +
      height_of_button_selection +
      height_of_sport_tab +
      height_of_betslip_tab +
      height_of_special_league 
    const height_of_balance = $balance.length > 0 ? $balance.outerHeight() + 15 : 5 //reuse for odds page end scroll
    const height_of_attention =  $attention.length ? $attention.outerHeight() : 0
    if ((bottom_of_screen > top_of_footer) && (top_of_screen < bottom_of_footer)) {
      // show footer
      const fixedPaddingOfLeftMenu = 15 // prevent left menu too close bottom of screen
      const heightOfFooterInViewport = currentViewport -  (top_of_footer - top_of_screen)
      const bodyPadding = $body.length > 0 ? parseInt($body.css("padding-bottom"), 10) : 0
      return currentViewport - heightOfFooterInViewport - totalFixedHeight - bodyPadding - fixedPaddingOfLeftMenu - height_of_balance - height_of_attention
    } else {
      // hide footer
      const fixedPaddingOfLeftMenu = 9 // prevent left menu too close bottom of screen
      const height_of_ann = $announcements.length > 0 && top_of_screen === 0 ? $announcements.outerHeight(true) : 8 // outerHeight(true) means it include padding and margin
      return currentViewport - totalFixedHeight - fixedPaddingOfLeftMenu - height_of_ann - height_of_balance - height_of_attention;
    }

  }

  static scrollToTop = (speed = 'slow') => {
    $("html, body").animate({scrollTop: 0}, speed);
    if (window.env && !window.env.isB2B && CommonUtil.isIniFrame()) {
      /**
       * this code handle for Unified Account in Standard
       */
      window.parent.postMessage && window.parent.postMessage({
        event: "onscrolltotop"
      }, "*")
    }
  }

  static scrollToClass = (className, speed = 'slow') => {
    const selectedItem = $(`.${className}`);
    selectedItem.length && $("html, body").animate({scrollTop: selectedItem.offset().top - 300}, speed);
  }

  static isInvalidProductStatus(udata, productCode) {
    return !!udata && (udata.productStatus[productCode] === Product.INACTIVE || udata.productStatus[productCode] === Product.CLOSED);
  }

  static isProductSuspended(udata, productCode) {
    return !!udata && (udata.productStatus[productCode] === Product.WAGERING_SUSPENDED);
  }

  static isInvalidUserStatus(udata) {
      return udata.status === UserStatus.INACTIVE || udata.status === UserStatus.CLOSED;
  }
  
  static isUserSuspended(udata) {
      return udata.status === UserStatus.SUSPENDED || udata.status === UserStatus.SUSPENDED_BY_COMPANY;
  }
  
  static validateUserAndProduct(productCode) {
    let error = ''
    const __udata = JSON.parse(window.atob(localStorage.getItem('__udata'))) || null
    if (__udata.auth) {
      const isValidUser = !this.isUserSuspended(__udata) && !this.isInvalidUserStatus(__udata);
      const isValidProduct = !this.isProductSuspended(__udata, productCode) && !this.isInvalidProductStatus(__udata, productCode);
      if (!isValidUser || !isValidProduct) {
        const isCredit = __udata.mode === 'credit';
        if (this.isUserSuspended(__udata)) {
          error = isCredit ? 'Your account has been Suspended, please contact your Upline for help.' : 'Your account has been Suspended, please contact Customer Service for help.';
        } else {
          error = 'errors:This product is currently unavailable, please contact Customer Service for help.';
        }
      
      }
      if((productCode === PRODUCT_CODE.SB && __udata.isBlockedSBWagering)
      || (productCode === PRODUCT_CODE.HR && (__udata.isBlockedSBWagering || __udata.isBlockedHRWagering))) {
        error = 'errors:ERROR5002';
      }
    }
    return error
  }

  static formatSportNameOnUrl(sportName) {
    if (!_.isEmpty(sportName)) {
      const WHITE_SPACE = ' ', HYPHEN = '-', LEFT_BRACKET = '(', RIGHT_BRACKET = ')', EMPTY = ''
      let formatName = sportName.toLowerCase()
      if (formatName.indexOf(WHITE_SPACE) > -1) {
        formatName = formatName.replaceAll(WHITE_SPACE, HYPHEN)
      }
      if (formatName.indexOf(LEFT_BRACKET) > -1 || formatName.indexOf(RIGHT_BRACKET) > -1) {
        formatName = formatName.replaceAll(LEFT_BRACKET, EMPTY).replaceAll(RIGHT_BRACKET, EMPTY)
      }
      return formatName
    }
    return '';
  }

  static formatDatePickerFrom(date, format) {
    return date.format(format);
  }

  static formatDatePickerTo(date, format) {
    return moment(date).endOf('day').format(format);
  }

  //input: time is a moment
  static convertFmDateToServerTime = (time, format, userTimezone) => moment.tz(time.startOf('day').format(format), format, userTimezone).tz(Constants.SERVER_TIME_ZONE_ID).format(format);

  //input: time is a moment
  static convertToDateToServerTime = (time, format, userTimezone) => moment.tz(time.endOf('day').format(format), format, userTimezone).tz(Constants.SERVER_TIME_ZONE_ID).format(format);

  //input: time is a string
  static convertServerToUserTime = (time, format, userTimezone) => moment.tz(time, format, Constants.SERVER_TIME_ZONE_ID).tz(userTimezone);
  
  static removeCommas(value) {
    if (value) {
      return _.replace(value, /,/g, '');
    }
    return null;
  }

  static getSportNameForUrl(sports, sportName, defaultSportId) {
    return Object.keys(sports).reduce((name, sportId) => {
      if (CommonUtil.formatSportNameOnUrl(sports[sportId]) === sportName) {
        return name = sportName
      }
      return name
    }, CommonUtil.formatSportNameOnUrl(sports[defaultSportId]))
  }

  static getDefaultSportNameForSportTab = (sports) => {
    let sportName = ''
    if (sports.length > 0) {
      sportName = sports[0][SportItemMap.id] === Constants.ESPORT_ID ? sports[1][1][SportItemMap.name] : sports[0][1][SportItemMap.name]
    }
    if (sportName) {
      return CommonUtil.formatSportNameOnUrl(sportName)
    }
  }

  static checkShowTitleTooltip = () => {
    const elements = document.querySelectorAll('.title-tooltip');
    if (!_.isEmpty(elements)) {
      _.forEach(elements, element => {
        const classList = element.classList;
        const hasShowClass = classList.contains('show');
        //check case if element.offsetWidth === element.scrollWidth at firefox browser
        const isEllipsSpanFireFox = element.offsetWidth === element.scrollWidth;
        //check to show tooltips at span tag
        const isEllipsisActiveSpan =(isEllipsSpanFireFox || element.scrollWidth === 0) && element.parentElement.offsetWidth < element.parentElement.scrollWidth;
        const isEllipsisActive = element.offsetWidth < element.scrollWidth || isEllipsisActiveSpan;
        if (isEllipsisActive) {
          if (!hasShowClass) {
            classList.add('show');
          }
        } else if (hasShowClass) {
          classList.remove('show');
        }
      });
    }
  }

  static currentUTCDate = (timeZone) => {
    const utcOffset = timeZone ? timeZone : "GMT-04:00";
    return moment().utcOffset(utcOffset);
  }

  static getStartOfUTCDate = (date, timeZone) => {
    const utcOffset = timeZone ? timeZone : "GMT-04:00";
    return moment(date).startOf('day').utcOffset(utcOffset);
  }

  static getEndOfUTCDate = (date, timeZone) => {
    const utcOffset = timeZone ? timeZone : "GMT-04:00";
    return moment(date).endOf('day').utcOffset(utcOffset);
  }

  static utcDateFormat = (date, format, timeZone) => {
    const utcOffset = timeZone ? timeZone : "GMT-04:00";
    const formatString = format ? format : "DD/MM/YYYY HH:mm:ss";
    return moment(date).utcOffset(utcOffset).format(formatString);
  }

  static convertToFavouriteArray(objectId) {
    return [{id: objectId, date: Number(new Date())}]
  }

  static getMapBlockedProducts(__udata) {
    if (!__udata) return {};
    const blockedProducts = __udata.blockedProducts || [];
    const currentCountry = __udata.country || "Others";
    const currentCurrency = __udata.currency || "";
    return Object.keys(blockedProducts).reduce((acc, productCode) => {
      const blockedDetails = blockedProducts[productCode];
      const blockCountries = blockedDetails.blockCountry;
      const blockCurrencies = blockedDetails.blockCurrency;
      const isBlockedCountry = !_.isEmpty(blockCountries) && blockCountries.split(",").find(country => country === currentCountry);
      const isBlockedCurrency = !_.isEmpty(blockCurrencies) && blockCurrencies.split(",").find(currency => currency === currentCurrency);
      if (isBlockedCountry || isBlockedCurrency) {
        acc[productCode] = blockedDetails;
      }
      return acc;
    }, {})
  }

  static isBlockedLiveSport(listBlockLiveSports, sportId, market) {
    return market === Market.Live && _.includes(listBlockLiveSports, sportId);
  }

  static isMatchLandingPageURL() {
    const pathname = window.location.pathname;
    let isEndWithLocale = false;
    Object.keys(LocalePath).every(key => {
      if (pathname === `/${LocalePath[key]}` ||  pathname === `/${LocalePath[key]}/`) {
        isEndWithLocale = true;
        return false;
      }
      return true;
    });
    return isEndWithLocale;
  }

  static setBase64LocalStorage(key, value) {
    localStorage.setItem(key, window.btoa(unescape(encodeURIComponent(JSON.stringify(value)))));
  }

  static getBase64LocalStorage(key) {
    return decodeURIComponent(escape(window.atob(localStorage.getItem(key))));
  }

  static getSportIdFromSportNameOnUrl = (urlSportName) => {
    const originName = Object.values(ALL_SPORTS).filter(sportName => CommonUtil.formatSportNameOnUrl(sportName) === urlSportName)[0];
    if (originName) {
      return SPORT(originName);
    }
    return Constants.SOCCER_ID;
  }

  static isIniFrame = () => {
    return window.self !== window.top;
  }

  static getCookiePrefsByKey = (key) => {
    const __prefs = _.isEmpty(cookie.load('__prefs')) ? '' : CommonUtil.decodeBase64(cookie.load('__prefs'));
    const __prefsJSON = _.isEmpty(__prefs) ? {} : CommonUtil.convertStringToJSON(__prefs);
    return !_.isEmpty(__prefsJSON) && __prefsJSON[key];
  }

  static convertBetAcceptanceType(inPlay, betAcceptanceType) {
    if (inPlay) {
      switch (betAcceptanceType) {
        case 1:
          return 'DANGER_ZONE';
        case 2:
          return 'LIVE_DELAY';
        default:
          return 'LIVE';
      }
    }
    return null;
  }

  static postMessage = (message, params = {}) => {
    window.parent.postMessage && window.parent.postMessage({
      ...params,
      event: message
    }, "*")
  }

  static getAvailableViews = () => {
    const supportedViews = {};
    const isAvailableEuroViewURL = !!(window.env.futureViewURL || window.env.fvURL || window.env.enableNewStandardView);
    supportedViews[ViewKeys.asia] = window.env.isEnableOldAsianView;
    supportedViews[ViewKeys.europe] = window.env.isEnableOldEuroView;
    supportedViews[ViewKeys.compact] = window.env.isEnableNewAsianView;
    supportedViews[ViewKeys.classic] = window.env.isEnableClassicView;
    supportedViews[ViewKeys.standard] = window.env.isEnableFutureView && isAvailableEuroViewURL;
    return supportedViews;
  }
  
  static getUserSettingViewsByKey = (key) => {
    switch (key) {
      case ViewKeys.classic:
        return VIEW.CLASSIC;
      case ViewKeys.compact:
        return VIEW.COMPACT
      case ViewKeys.europe:
        return VIEW.EUROPE;
      case ViewKeys.standard:
        return  VIEW.STANDARD;
      default:
        return VIEW.ASIAN
    }
  }


  static getAvailableViews = () => {
    const supportedViews = {};
    supportedViews[ViewKeys.asia] = window.env.isEnableOldAsianView;
    supportedViews[ViewKeys.europe] = window.env.isEnableOldEuroView;
    supportedViews[ViewKeys.compact] = window.env.isEnableNewAsianView;
    supportedViews[ViewKeys.classic] = window.env.isEnableClassicView;
    supportedViews[ViewKeys.standard] = window.env.isEnableFutureView;
    return supportedViews;
  }

  static getUserSettingViewsByKey = (key) => {
    switch (key) {
      case ViewKeys.classic:
        return VIEW.CLASSIC;
      case ViewKeys.compact:
        return VIEW.COMPACT
      case ViewKeys.europe:
        return VIEW.EUROPE;
      case ViewKeys.standard:
        return  VIEW.STANDARD;
      default:
        return VIEW.ASIAN
    }
  }

  static isWhitelabel() {
    return window.env.isWhiteLabel;
  }

  static isShowNoTopLeagueIcon() {
    return SHOW_NO_TOPLEAGUE_ICON.includes(window.env.skinName);
  }

  static convertTextToSearch(text) {
    return text.trim().replace(/\s\s+/g, ' ');
  }

  static getOddsFormatKeys(currency, userMode, oddsFormatSetting) {
    const disabledOddsFormat = [];
    // build available odds format based on settings
    if (oddsFormatSetting.indexOf('EU') === -1) {
      disabledOddsFormat.push('Decimal');
    }
    if (oddsFormatSetting.indexOf('HK') === -1) {
      disabledOddsFormat.push('HongKong');
    }
    if (oddsFormatSetting.indexOf('ID') === -1) {
      disabledOddsFormat.push('Indonesian');
    }
    if (oddsFormatSetting.indexOf('MY') === -1) {
      disabledOddsFormat.push('Malay');
    }
    if (oddsFormatSetting.indexOf('AM') === -1) {
      disabledOddsFormat.push('American');
    }

    let defaultKeys = _.omit(OddsFormatMB, disabledOddsFormat);
    let keys = {};

    switch(userMode.toUpperCase()) {
      case PLAYER_TYPE.CREDIT:
        keys = defaultKeys;
        break;
      case PLAYER_TYPE.CASH:
        if (!currency) {
          keys = defaultKeys;
        } else if (currency === 'IDR') {
          keys = {Indonesian: 3};
        } else {
          keys = _.omit(defaultKeys, 'Indonesian');
        }
        break;
      default:
        keys = _.omit(defaultKeys, 'Indonesian');
        break;
    }
    return keys;
  }

  /**
   * Convert text from 'convert to slug' to 'convert-to-slug'
   * @param {*} text 
   */
  static convertToSlug(text) {
    return text
      .trim()
      .toLowerCase()
      .replace(/[-]+/g, ' ')
      .replace(/  +/g, ' ')
      .replace(/ /g,'-')
      .replace(/[$&+,:;=?[\]@#|{}'<>.^*()%!/]/g,'');
  }

  static refreshSalesforceLanguage = () => {
    const embedded = document.getElementsByClassName('embeddedServiceHelpButton')[0];
    if (embedded) {
      const iframe = document.getElementById("esw_storage_iframe");
      if (iframe) {
        const parts = iframe.src.split("?parent=");
        if (parts[1] !== document.location.href) {
          parts[1] = `?parent=${document.location.href}`;
          iframe.onload = () => {
            let refreshUrl = "";
            const scripts = document.getElementsByTagName("script");
            const sfScripts = Array.from(scripts).filter(script => script.src.includes('EmbeddedServiceConfig.language'));
            
            sfScripts.forEach((s, idx) => {
              const searchParams = new URLSearchParams(s.src);
              const currentLang = searchParams.get('EmbeddedServiceConfig.language');
              if (currentLang !== window.embedded_svc.settings.language) {
                // updateIframe = true;
                refreshUrl = !refreshUrl 
                  ? s.src.replace(currentLang, window.embedded_svc.settings.language)
                  : refreshUrl;
                //remove old script
                s.parentElement.removeChild(s);
              }
            })

            if (refreshUrl) {
              // add script with new lang
              const script = document.createElement('script');
              script.type = "text/javascript";
              script.async = true;
              script.src = refreshUrl;
              document.body.appendChild(script);
            }
          }
          iframe.src = parts.join("");
        }
      }
    }
  }

  static generateSurvey = (promotionDesc, promotionId) => {
    const regEx = new RegExp('<\\s*a\\s*href="/r=survey&amp;sid=(.*?)">(.*?)<\\s*/\\s*a>', 'g');
    let match;
    const lang = CommonUtil.getCurrentLang() || 'en';
    const left = (window.screen.width - 708) / 2;
    while ((match = regEx.exec(promotionDesc)) !== null) {
      promotionDesc = promotionDesc.replaceAll(match[0], `<a onclick=\"window.open('/${lang}/survey/${match[1]}/${promotionId}', 'PromotionSurvey', 'width=708,height=900,resizable=yes,scrollbar=no,left=${left}'); return false;\">${match[2]}</a>`)
    }
    return promotionDesc;
  }

  static getGradingUnit = (sportId, gradingUnit) => {
    if(window.env.isShowGradingUnit && sportId === Constants.TENNIS_ID && gradingUnit)
      return `(${i18next.t(gradingUnit)})`;
    return '';
  }

  static getIdsEvent = (events) => {
    return events ? (events.type ? events.ids : (events.ids && events.ids[0] ? events.ids[0].id : '')) : '';
      //if has events.type, it's searching for league. If not, it's searching for event.
  }

  static getRedCard = (matchRedCard, periodInfo, periods, isRunningExtraTime = false) => {
    if(periods < 0) {
      return [0, 0];
    }
    let result = [0, 0];
    if(parseInt(periods) !== 3 || isRunningExtraTime) {
      result = periodInfo ? periodInfo[10] || [0, 0] : matchRedCard;
    }
    return result;
  }

  static countRowSpanMoreBet = (sportId, periodsEvent = [], event, isEsport = false, maxLines, marketPeriod  = 0, isSingleLine = false, periodsRightLayout = []) => {
    const fullTime = event && event[EventDetail.periods] ? event[EventDetail.periods][marketPeriod] || [] : [];
    const rightPeriods = !isEsport && periodsRightLayout.length > 0 ? periodsRightLayout[0] : '';
    const haftTime = event && event[EventDetail.periods] && rightPeriods ? event[EventDetail.periods][rightPeriods] || [] : [];
    const ftHDP = fullTime[0] || [], ftOU  = fullTime[1] || [], htHDP = haftTime[0] || [], htOU = haftTime[1] || [];
    const numLine = isEsport ? Math.max(ftHDP.length, ftOU.length) : Math.max(ftHDP.length, ftOU.length, htHDP.length, htOU.length);
    const rowDefault = marketPeriod > 0 ? 0 : 1; // return 1 for more market
    let countRowSpan = Math.min(numLine , maxLines) || rowDefault;
    const periodDisplay = CommonUtil.getAllDisplayPeriods(sportId) || [];
    if(periodDisplay && periodDisplay.length > 0 && !isEsport) {
      const filterPeriods = periodsEvent.filter(period => periodDisplay.includes(parseInt(period))) || [];
      filterPeriods.forEach(period => {
        const oddsData = event && event[EventDetail.periods] && event[EventDetail.periods][period] || [];
        const dataHDP = oddsData[0] || []; 
        const dataOU = oddsData[1] || [];
        const dataML = !isSingleLine && oddsData[2] && oddsData[2].length > 0 ? 1 : 0;
        countRowSpan = countRowSpan + (Math.min(Math.max(dataHDP.length, dataOU.length, dataML), maxLines) || 0);
      });
    }
    return countRowSpan;
  }

  static countMoreBetSingleLine = (sportId, event, isParlay = false) => {
    const sportPeriod = CommonUtil.getAllDisplayPeriods(sportId) || [];
    let numMoreBet = event[EventDetail.moreBets] + (isParlay ? 0 : event[EventDetail.totalOutrightOdds]);
    sportPeriod.forEach(period => {
      if(event && event[EventDetail.periods] && event[EventDetail.periods][period] && event[EventDetail.periods][period][2]) {
        numMoreBet += 1;
      } 
    });
    return numMoreBet;
  }

  static fetchOddsByPeriods = (sportId, leftPeriod = 0, periodsRightLayout, event) => {
    const periodsDefault = [parseInt(leftPeriod), periodsRightLayout];
    if (leftPeriod > 0) {
      return [periodsDefault];
    }
    const periodEvent = Object.keys(event[EventDetail.periods]).filter(period => parseInt(period) !== 0 && !periodsRightLayout.includes(parseInt(period)));
    if(periodEvent && periodEvent.length > 0) {
      const periods = CommonUtil.sortPeriods(periodEvent.map(Number), PERIODS_PRIORITY[sportId]);
      const displayPeriods = CommonUtil.displayPeriodsOdds(sportId, periods);
      displayPeriods.unshift(periodsDefault);
      return displayPeriods;
    }
    return [periodsDefault];
  }

  static displayPeriodsOdds = (sportId, periodEvent) => {
    let result = [];
    const noDisplayOdds = [];
    const leftColumn = CommonUtil.getSubPeriodsLeft(sportId) || [];
    const rightColumn = CommonUtil.getSubPeriodsRight(sportId) || [];
    if (leftColumn.length > 0 || rightColumn.rightColumn > 0) {
      periodEvent.forEach(period => {
        if (leftColumn.includes(period)) {
          result.push([period, noDisplayOdds]);
        } else if (rightColumn.includes(period)) {
          result.push([-1, [period]]);
        }
      });
    }
    return result;
  }

  static isShowPeriodName = (sportId) => {
    return Object.keys(CommonUtil.parseSportPeriods()).some(id => sportId === parseInt(id));
  }

  static sortPeriods = (eventPeriods, priority = []) => {
    let result = [];
    if (Array.isArray(eventPeriods) && eventPeriods.length > 0) {
      const currentPriority = priority.filter(period => eventPeriods.includes(period));
      const combinedPeriods = currentPriority.concat(eventPeriods)
      result = [...new Set(combinedPeriods)]
    }
    return result;
  }

  static parseJsonConfig = (paramConfig) => {
    let result = {};
    if(paramConfig && typeof(paramConfig) === 'string') {
      result = JSON.parse(paramConfig) || {};
    }
    return result;
  }

  static parseSportPeriods = () => {
    return CommonUtil.parseJsonConfig(window.env.periodsDisplayOddsPage);
  }

  static getMainPeriods = (sportId) => {
    const sportPeriods = CommonUtil.parseSportPeriods();
    const periodsDefault = sportPeriods && sportPeriods[Constants.DEFAULT_DISPLAY_ID]
                            ? sportPeriods[Constants.DEFAULT_DISPLAY_ID][Constants.MAIN_PERIODS_INDEX] : [];
    const periods = sportPeriods && sportPeriods[sportId] ? sportPeriods[sportId] : [];
    return periods && periods[Constants.MAIN_PERIODS_INDEX] && periods[Constants.MAIN_PERIODS_INDEX].length > 0
          ? periods[Constants.MAIN_PERIODS_INDEX] 
          : periodsDefault;
  }

  static getSubPeriods = (sportId) => {
    const sportPeriods = CommonUtil.parseSportPeriods();
    const periodsDefault = sportPeriods && sportPeriods[Constants.DEFAULT_DISPLAY_ID]
                            ? sportPeriods[Constants.DEFAULT_DISPLAY_ID][Constants.SUB_PERIODS_INDEX] : [];
    const periods = sportPeriods && sportPeriods[sportId] ? sportPeriods[sportId] : {};
    return periods && periods[Constants.SUB_PERIODS_INDEX] && periods[Constants.SUB_PERIODS_INDEX].length > 0
          ? periods[Constants.SUB_PERIODS_INDEX] 
          : periodsDefault;
  }

  static mergePeriods = (periods = []) => {
    let result = [];
    if(periods && periods.length > 0) {
      periods.forEach(period => {
        if (Array.isArray(period)) {
          period.forEach(pe => result.push(parseInt(pe)));
        } else {
          result.push(parseInt(period));
        }
      });
    }
    return result;
  }

  static getAllDisplayPeriods = (sportId) => {
    const mainPeriod = CommonUtil.mergePeriods(CommonUtil.getMainPeriods(sportId)) || [];
    const subPeriod = CommonUtil.mergePeriods(CommonUtil.getSubPeriods(sportId)) || [];
    return mainPeriod.concat(subPeriod) || "";
  }

  static getSubPeriodsLeft = (sportId) => {
    return CommonUtil.getSubPeriods(sportId)[Constants.SUB_PERIODS_LEFT] || [];
  }
  
  static getSubPeriodsRight = (sportId) => {
    return CommonUtil.getSubPeriods(sportId)[Constants.SUB_PERIODS_RIGHT] || [];
  }

  static getPageTitle = () => {
    if (window.env.isB2B) {
      return window.env.metaTitle;
    }
    
    const currentPage = PAGE_TITLE[CommonUtil.getCurrentPage()];
    const originalKey = `${CommonUtil.getCurrentSkin()}.${currentPage ? currentPage : 'pageTitle'}`;
  
    const defaultPageTitle = i18next.t('pa.pageTitle');
    return i18next.t(originalKey, defaultPageTitle)
  }

  static checkProductStatusWhenAccess() {
    return _.get(window.env, 'checkProductStatusWhenAccess');
  }
  
  static getInitialProps(components, componentName) {
    return components.reduce(
      (rs, component) => {
        rs[component.componentName] = component.initialData;
        return rs;
      }, 
      {}
    )[componentName]
  }
  
  static getPeriodNumParam(period) {
    return period > 0 ? period : -1;
  }

  static isNotSupportPublicClassFields() {
    const agent = window.navigator.userAgent;
    const browsers = agent.match(/(Chrome|Version(?=\/))\/?\s*(\d+)/i);
    const isChrome = browsers && browsers[1] === 'Chrome';
    const isSafari = !isChrome && browsers && browsers[1] === 'Version';
    if (isChrome) {
      return browsers[2] < Constants.VERSION_NOT_SUPPORTED.CHROME;
    } else if (isSafari){
      return browsers[2] < Constants.VERSION_NOT_SUPPORTED.SAFARI;
    }
    return false;
  } 

  static isLeaderboard() {
    return window.location.pathname.includes(window.env.leaderBoardPathName) && window.env.enableLeaderboard;
  }

  static getLastKeyInMap(map) {
    return Array.from(map)[map.size-1][0];
  }

  static isBetBuilder() {
    return window.location.pathname.includes(Constants.BETBUILDER_PATH);
  } 
  
  static isIOSDevice() {
    const agent = window.navigator.userAgent;
    const iPhoneRegex = /iPhone/i
    return iPhoneRegex.test(agent);
  }

  static addExtraProps(Component, extraProps) {
    return Component && <Component.type {...Component.props} {...extraProps} />;
  }

  static isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
  }

  static isEnableFeatureVIP() {
    return window.env.enableFeatureVIP;
  }

  static isVIPAccount() {
    const { auth, currentTierId } = {...CommonUtil.getUserData()}
    return CommonUtil.isEnableFeatureVIP() && auth && currentTierId > 1
  }
  
  static getGameByPath(position, url) {
    const arrPath = url ? url.split('/') : window.location.href.split('/');
    return arrPath[position] ? arrPath[position] : '';
  }

  static isMobile() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return (/(android|bb\d+|meego).+mobile|KFTHWI|KFAPWI|Kindle|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android/i.test(userAgent) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4)));
    }

  static isNewUserAgentChrome() {
    const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    const version = raw ? parseInt(raw[2], 10) : 0;
    return version >= 110;
  }

  static async isGalaxyZFold() { // Samsung fold devices have model name: SM-F9xxx

    if(this.isNewUserAgentChrome()) { // https://developers.google.com/privacy-sandbox/blog/user-agent-reduction-android-model-and-version
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const data = await navigator.userAgentData.getHighEntropyValues(['model']);
      return /SM-F9/i.test(data.model) && /android/i.test(userAgent)
    }

    return false
  }

  static isSmartPhone() {
    /*
    https://developers.google.com/search/blog/2011/03/mo-better-to-also-detect-mobile-user
    https://stackoverflow.com/questions/5341637/how-do-detect-android-tablets-in-general-useragent
    */
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return this.isMobile() && (/mobile/i.test(userAgent) && !/ipad|tablet/i.test(userAgent));
  }

  static isTablet() {
    /*
    https://developers.google.com/search/blog/2011/03/mo-better-to-also-detect-mobile-user
    https://stackoverflow.com/questions/5341637/how-do-detect-android-tablets-in-general-useragent
    */
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return this.isMobile() && !(/mobile/i.test(userAgent) && !/ipad|tablet/i.test(userAgent));
  }
  
  static getGameByPath(position, url) {
    const arrPath = url ? url.split('/') : window.location.href.split('/');
    return arrPath[position]
  }
  //return true if product status = Active
  static validateProduct = (user, productName) => {
    const __udata = CommonUtil.getUserData();
    const mapBlockedProducts = CommonUtil.getMapBlockedProducts(__udata);
    const productStatus = _.get(user, 'productStatus.' + productName);
    const isInvalidProductStatus = CommonUtil.isInvalidStatus(productStatus);
    if (isInvalidProductStatus || mapBlockedProducts[productName]) {
      return false;
    }
    return true;
  }

  static isDetailGameURL = (productCode) => {
    return productCode && !Object.values(casinoPage).includes(productCode);
  }

  static generateSubscribeMessage = (destination, body = {}, otherField = {}) => {
  return (
      {
        type: MESSAGES_TYPE_WS.SUBSCRIBE,
        destination: destination,
        body: {
          ...body,
          locale: CommonUtil.getCurrentLocaleCode()
        },
        ...otherField
      }
    )
  }

  static generateUnSubscribeMessage = (destination) => ({
    type: MESSAGES_TYPE_WS.UNSUBSCRIBE,
    destination: destination,
  })

  static isLogo25YearEnabled = (logoTimes) => {
    if (!logoTimes) return false;
    const currentDate = new Date().getTime();
    const startDate = new Date(logoTimes.startDate).getTime();
    const endDate = new Date(logoTimes.endDate).getTime();
    return startDate <= currentDate && currentDate <= endDate;
  }

  static getDatesRangeSpecialDate = (key, defaultDatesRange = Constants.DEFAULT_LOGO_DATES) => {
    const localStorageTimes = CommonUtil.convertStringToJSON((localStorage.getItem(key)));
    if (!_.isEmpty(localStorageTimes)) {
      return localStorageTimes;
    }
    return window.env && window.env[key] && !_.isEmpty(CommonUtil.convertStringToJSON(window.env[key]))
        ? CommonUtil.convertStringToJSON(window.env[key])
        :  defaultDatesRange;
  }

  static generateStatsPageURL(sportName, leagueName, eventName, eventId, view) {
    const leagueNameFormat = leagueName.replaceAll(" - ", "-").replaceAll(" ", "-")
    const eventNameFormat = eventName.replaceAll(" - ", "-").replaceAll(" ", "-")
    return `/${CommonUtil.getCurrentLang()}${view}/sports/${sportName.toLowerCase()}/stats/${leagueNameFormat}/${eventNameFormat}/${eventId}`
  }

  static openImageNewTab = (imgSrc) => {
    const image = new Image();
    image.src = imgSrc;
    window.open("about:blank").document.write(image.outerHTML);
  }


  static getDefaultLanguageByBrand = (lang) => {
    const langSupports = window.env.langSupports
    const defaultLanguageByBrand = window.env.defaultLanguageByBrand
    const languageCode = defaultLanguageByBrand === 'en-GB'
      ? 'en_US'
      : langSupports.includes(defaultLanguageByBrand) 
        ? defaultLanguageByBrand 
        : langSupports[0];

    return langSupports.includes(CommonUtil.mapLangCountryCode[lang])
      ? lang
      : _.invert(CommonUtil.mapLangCountryCode)[languageCode.replace("-", "_")];
  }
  // check if propslabel is Yes/No
  static isHiddenHandicap = (propsLabel) => {
    return ['Yes', 'No'].includes(propsLabel);
  }
  static getEuroViewURL = (lang) => {
    return window.env.enableNewStandardView
      ? Constants.NEW_EURO_VIEW_URL.replace('{locale}', lang)
      : window.env.futureViewURL + '/' + lang
  }

  static getB2BEuroViewURL = (lang) => {
    return window.env.enableNewStandardView
      ? Constants.NEW_EURO_VIEW_URL.replace('{locale}', lang)
      : window.env.fvURL.replace('{locale}', lang)
  }

  static isOpenNewBetslipPopup = () => {
    const __udata = CommonUtil.getUserData();
    return window.env.enableNewBetslip && __udata.newBetslipPopupEnabled && !localStorage.getItem("_needToChangePW")
  }

  static handleZoomOutWindow = () => {
    const zoomOutRatio = window.innerWidth / Constants.WINDOW_ZOOM_OUT_BREAKPOINT

     // Zoom out on device has screen width < mininum body width
    document.getElementById("wrapper").style.zoom = zoomOutRatio < 1 ? zoomOutRatio : 'normal'
  }

  /**
   * to format Time zone Code
   * input ex:UTC +12:45
   * output ex :+12:45
   */
  static formatTimeZoneCode = (timeZoneCode) => {
    if (!timeZoneCode) return "";
    const splitValue = timeZoneCode.split(" ");
    if (splitValue.length === 1) return "";
    let text = timeZoneCode.split(" ")[1];
    const sufix = ":00";
    switch (text.length) {
      case 2:
        // for timeZone with 2 character like +9
        return text.replace(text.substring(0, 1), text.substring(0, 1).concat('0')).concat(sufix);
      case 3:
        // for timeZone with 3 character +10
        return text.concat(sufix);
      case 5:
        // for timeZone like +9:30
        return text.replace(text.substring(0, 1), text.substring(0, 1).concat('0')).concat(text.substring(1, text.length));
      default:
        //ignore if timeZone length is higher than 3 character for Example:GMT +12:45
        return text;
    }
  }
  
  static getMarketName = (marketName, periodsDescription, sportId, specificLanguage) => {
    return !parseInt(marketName)
      ? i18next.t(marketName, specificLanguage)
      : CommonUtil.getPeriodName(
          periodsDescription,
          parseInt(sportId) ? sportId : Constants.ESPORT_ID,
          marketName,
          false
        )
  }

  static getOTBMarketTitle(options, market, betTypeGroup, periodsDescription, isSearchOddsBar, isHighLight, specificLanguage) {
    let marketName = '';
    const { period, sportId } = options;
    if (isHighLight) return marketName;
    if (period > 0 && !isSearchOddsBar) {
      marketName = period;
    } else if (_.includes([Market.Early, Market.Today, Market.ALL, Market.Live], market)) {
      const marketDetail = _.invert(BetTypeGroup)[betTypeGroup];
      const prefix = _.get(PREFIX_SPORT_TRANSLATION, `${sportId}`, 'others');
      if (marketDetail) {
        marketName = `${prefix}:${marketDetail}`;
      }
    }
    return CommonUtil.getMarketName(marketName, periodsDescription, sportId, specificLanguage);
  }

  static getOTBPrefixTitle(sportId, market, isLive, isHighLight, specificLanguage) {
    const isHighLightEarlyMarket = isHighLight && market === Market.Early;
    let prefixTitle = CommonUtil.getMarketTabName(sportId, market);
    if (isLive) {
      prefixTitle = "Live"
    } else if(isHighLightEarlyMarket) {
      prefixTitle = "HighLight";
    }
    return i18next.t(prefixTitle, specificLanguage);
  }

  static getOddsTableBarMarket = (isToday, isEarly, optionsMarket) => {
    return isToday ? Market.Today : isEarly ? Market.Early : optionsMarket
  }

  static getMarketTabName(sportId, market) {
    const currentMarket = sportId === Constants.ESPORT_ID
      ? _.invert(EsportMarket)[market]
      : _.invert(Market)[market];
    return currentMarket === "PreGame" ? "Pre-game" : currentMarket;
  }

  static convertPeriodDescriptionData(data) {
    return data.map(periods => ({
      sportId: periods[GROUP_SPORT_PERIODS.sportId],
      periodsDescription: periods[GROUP_SPORT_PERIODS.groupPeriod]
    }));
  }
}


// WEBPACK FOOTER //
// ./src/app/common/CommonUtil.js